import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse, HttpErrorResponse,
         HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';


import { Observable, observable, throwError } from 'rxjs';
import { map, finalize, catchError } from "rxjs/operators";

import { MzModalService } from 'ngx-materialize';
import { LoadingService } from '../_services/loading.service'
import { MzToastService } from 'ngx-materialize';
import { ToastrService} from 'ngx-toastr';

import { AuthenticationService } from '../_services/authentification.service';
import { Globals } from '../_services/zero/globals';
import { Role } from '../_models/oauth.models'
import { errorHandler } from '@angular/platform-browser/src/browser';

/* 
 * Settea credenciales de autentificacion al header http
 * Intercepta errores de request
 * Administra loading de peticiones htttp
 * 
 * by: jsoler
 */
@Injectable() export class JwtInterceptor implements HttpInterceptor {
   
    activeRequests: number = 0;
    errorCodeServer: number = 0;
    errorCode: number = 0;

    constructor(private authenticationService: AuthenticationService, 
                private toastService: MzToastService,
                private modalService: MzModalService, 
                private global:Globals,
                private loadingService: LoadingService,
                private toastr: ToastrService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.errorCodeServer = 0;
        this.errorCode = 0;
        // agrega header con autentificacion 
        let currentUser = this.authenticationService.currentUserValue;     
        
        if (currentUser) {            
            request = request.clone({
                setHeaders: {                     
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'withCredentials': 'true',
                    'Access-Control-Allow-Origin': '*',
                    "Authorization": "Basic " + btoa( currentUser.username+':'+currentUser.token)
                }
            });
        }                  

        // activa loading
        if (this.activeRequests === 0) {
            this.loadingService.startLoading();
        }
        this.activeRequests++;

        return next.handle(request)
        .pipe( map( (event: HttpEvent<any>) => {
            
             if (event instanceof HttpResponse) {
                if (event.status != this.errorCode) {
                    //  200=ok 201=created
                    if( event.status == 200 || event.status == 201)  {

                        if( event.body && event.body.responseMessage && event.body.responsecode != 0) {
                            this.toastr.warning('<h5>Mensaje de sistema...</h5> <span>' + event.body.responseMessage + '</span>', "", 
                            {closeButton:false, enableHtml:true, disableTimeOut:false});
                        }
                        

                    } else if( event.status == 401 ) {
                        console.error('--!> Servicio no autorizado ...');
                        this.toastr.error('<h5>Acceso denegado ...</h5> <span>No se puede tener acceso al servidor.</span>', "", 
                            {closeButton:true, enableHtml:true, disableTimeOut:true});
                        
                    } else {
                        this.toastr.error('<h5>Error de sistema ..</h5> <span>A ocurrido un error interno en el sistema, intente nuevamente.</span>', "", 
                            {closeButton:true, enableHtml:true, disableTimeOut:true});
                    }
                
                    this.errorCode = event.status;
                }            
              }               

              return event;
        }, finalize(() => {
            // Desactiva loading
            this.activeRequests--;
            if (this.activeRequests === 0) {
                this.loadingService.stopLoading();
            }
        }))
        , catchError((error: HttpErrorResponse) => {
            if (error.status != this.errorCodeServer) {            
            this.toastr.error('<h5>Error con la comunicación del servidor.</h5> <span>Revise su conexión de red y refresque su navegador web</span>', "", 
                 {closeButton:true, enableHtml:true, disableTimeOut:true});
                 this.errorCodeServer = error.status;
            } else if (error.status == undefined && this.errorCodeServer == 0) {
                this.toastr.error('<h5>Error de autenticaci&oacute;n.</h5> <span>Usuario y/o contraseña incorrectos</span>', "", 
                 {closeButton:true, enableHtml:true, disableTimeOut:true});
                 this.errorCodeServer = error.status;
            }
            return throwError(error);
        })            
        ) // end pipe         

        .pipe(
            finalize(() => {
                // Desactiva loading
                this.activeRequests--;
                if (this.activeRequests === 0) {
                    this.loadingService.stopLoading();
                }
            })
        ) // end pipe

    } // end function
}



